<template>
    <div v-show="show" :class="classes" role="alert">
        <div v-html="body"></div>
        <button type="button" v-if="dismissable" class="button" aria-label="Dismiss" @click.stop="hide(0)">
            <i class="fa-light fa-times"></i>
        </button>
    </div>
</template>

<script>
    export default {

        props: {
            message: String,
            type: String,
        },

        data() {
            return {
                body: '',
                classes: '',
                show: false,
                dismissable: false,
                timer: null
            }
        },

        created() {
            if (this.message) {
                this.flash(this.message, this.type);
            }

            window.events.on('flash', ([message, type, duration, dismissible]) => this.flash(message, type, duration, dismissible));
        },

        methods: {

            flash(message, type, duration, dismissible = false) {
                this.body = message;
                this.classes = 'notification notification-flash ' + type;
                this.show = true;
                this.dismissable = dismissible;
                if (! this.dismissable) {
                    this.hide(duration);
                }
            },

            hide(duration = 10) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                if (duration > 0) {
                    this.timer = setTimeout(() => {
                        this.show = false;
                    }, (duration * 1000));
                } else {
                    this.show = false;
                }
            }

        }
    }

</script>
